<template>
	<div class="role">	
		<div class="right-wrap">
			<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">爱汇海创</h2> 
			<el-table
				:data="tableData"
				style="width: 100%"
				border
				row-key="id"
				class="list" >
				<!-- <template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-download.png')"></el-image>
						<div class="empty-text">暂无数据</div>
					</div>
				</template> -->
				<el-table-column
					prop="created_at"
					label="统计"
					align="center"
					class-name="created_at"
				>	
					<template slot="header" slot-scope="{ column,$index }">
						<div class="time-header">
							统计
						</div>
					</template>
					<template slot-scope="scope">
						<div class="">{{scope.row.name}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="pay_mode"
					label="免费次数"
					align="center"
					class-name="pay_mode"
				>
					<template slot-scope="scope">
						<div class="">{{scope.row.t1 ? scope.row.t1 : '0'}}次</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="api"
					label="预付费次数"
					align="center"
					class-name="mobile"
				>
					<template slot-scope="scope">
						<div class="">
							{{scope.row.t2 ? scope.row.t2 : '0'}}次
						</div>
					</template>
				</el-table-column>
			</el-table>
			<el-form ref="form" class="edit-form" :model="form" label-width="140px">
				<el-form-item label="accessKey：">
					<el-input class="title-input" v-model="form.accessKey" @keyup.native="handleAccessKey"></el-input>
				</el-form-item>
				<el-form-item label="免费次数：">
					<el-input class="title-input" v-model="form.t1" @keyup.native="handleFree"></el-input>
				</el-form-item>
				<el-form-item label="预付费次数：">
					<el-input class="title-input" v-model="form.t2" @keyup.native="handlePay"></el-input>
				</el-form-item>
			</el-form>
			<div class="submit-cell">
				<el-button class="submit-btn" @click="handleSubmit">提交</el-button>
			</div>
			
		</div>
	</div>
</template>

<script>
	import { getAihuiTime } from "@/utils/axios.js"
	
	export default{
		name: 'adminCompanyAihui',
		data () {
			return {
				form:{
					accessKey: '',
					t1: '',
					t2: '',
				},
				tableData: [],
				adminId: '',
				mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
			}
		},
		watch:{
			'form.accessKey':{
				handler(val){
					if(val) {
						this.form.accessKey = val.replace(/\s+/g,"")
					}
					
				},
				deep:true,
				immediate:true
			},
		},
		mounted() {
			let adminId = JSON.parse(localStorage.getItem('userInfo')) ? JSON.parse(localStorage.getItem('userInfo')).issupper : '0'
			this.adminId = adminId
			this.handleLoad()
		},
		methods:{
			handleLoad() {
				getAihuiTime({act: ''}).then((res) => {
					if(res.code == 200){
						this.form.accessKey = res.data.accessKey
						let obj = {name: '已使用次数', t1: res.data.times.t1used, t2: res.data.times.t2used}
						let obj2 = {name: '剩余次数', t1: res.data.times.t1, t2: res.data.times.t2}
						this.tableData = [obj, obj2]
						
					}
				})
			},
			handleAccessKey() {
				
			},
			handleFree() {
				this.form.t1 = this.form.t1.replace(/[^\.\d]/g,'');
				this.form.t1 = this.form.t1.replace('.','');
			},
			handlePay() {
				this.form.t2 = this.form.t2.replace(/[^\.\d]/g,'');
				this.form.t2 = this.form.t2.replace('.','');
			},
			handleSubmit() {
				if(this.form.accessKey == '') {
					this.$myAlert({
						type: 'fail',
						title: 'accessKey不能为空'
					});
					return
				}
				if((this.form.t1 && this.form.t1 > 0) || (this.form.t2 && this.form.t2 > 0)) {
					getAihuiTime({
						act: 'update',
						accessKey: this.form.accessKey,
						t1: this.form.t1,
						t2: this.form.t2
					}).then((res) => {
						if(res.code == 200) {
							this.form.t1 = '';
							this.form.t2 = '';
							this.handleLoad()
							this.$myAlert({
								type: 'success',
								title: '提交成功！'
							});
						}
					})
				} else {
					this.$myAlert({
						type: 'fail',
						title: '请提交最少一个大于0的参数'
					});
				}
			}
			
		}
	}
</script>

<style scoped>
	
</style>
<style lang="scss" scoped>
	.role{
		position: relative;
		padding: 24px;
		width: 100%;
		height: 100%;
		overflow-y: auto;
		border: 12px solid #F2F4FA;
		.list {
			margin-top: 0.4rem;
		}
		
		.edit-form {
			width: 4.6rem;
			margin: 0.4rem auto;
		}
		
		.submit-cell {
			// width: 4rem;
			text-align: center;
		}
		
		.submit-btn {
			width: 120px;
			height: 38px;
			background: #6681FA;
			border-radius: 4px;
			font-size: 16px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #FFFFFF;
			border: none;
		}
	}
	
	
</style>